<template>
  <div class="px-4 w-full">
    <!-- Hero -->
    <div
      class="cloud-hero mb-4 flex flex-wrap items-center justify-center lg:items-start lg:justify-start z-40 relative text-white bg-no-repeat bg-cover"
      :style="{ backgroundImage: 'url(/img/cloud-bg.jpg)' }"
    >
      <div
        class="w-full lg:pt-40 lg:p-16 lg:w-1/2 p-8 flex flex-col justify-end text-white"
      >
        <div class="lg:border-l-8 lg:border-white lg:px-8">
          <h1 class="text-center lg:text-left">CareerWise Cloud</h1>
          <h4 class="mb-12 text-center lg:text-left hidden lg:block">
            The portal for the CareerWise community.
          </h4>
          <p class="text-center lg:text-left">
            Bringing Careers Advisors and organisations from around the country
            together to provide a safe space to share information.
          </p>
          <div
            class="mt-16 lg:hidden block flex flex-col items-center justify-center"
          >
            <button class="btn btn-trans-white" @click="signup">
              Enquire today
            </button>
            <p class="text-center">
              Already a member?
              <a
                :href="settings.central_domain_url + '/account'"
                class="font-semibold hover:text-cw-alt"
                >Sign in</a
              >
            </p>
          </div>
        </div>
      </div>

      <div
        class="hidden lg:flex cloud-gradient p-8 lg:p-32 relative lg:h-full w-full lg:w-1/2 flex-col justify-center items-center"
      >
        <h1 class="text-center">Want to join the CareerWise community?</h1>
        <button class="btn btn-trans-white" @click="signup">FREE TRIAL</button>
        <p class="text-center">
          Already a member?
          <a
            :href="settings.central_domain_url + '/account'"
            class="font-semibold hover:text-cw-alt"
            >Sign in</a
          >
        </p>
      </div>
    </div>
    <!-- /Hero -->

    <!-- Latest posts -->
    <div class="w-full flex lg:flex-nowrap flex-wrap h-full items-center">
      <div
        class="w-full h-full lg:w-3/12 mr-4 p-8 space-y-4 text-cw-900 lg-block flex flex-col items-center lg:items-start justify-center"
      >
        <h1 class="">The latest posts</h1>

        <button class="btn btn-cw-alt" @click="signup">
          Sign up to view all posts
        </button>
      </div>

      <!-- posts -->
      <div
        v-if="posts && posts.length > 0"
        class="w-full lg:w-9/12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-12 bg-truegray-100"
      >
        <PostsCard
          v-for="(post, i) in posts.slice(0, 3)"
          :id="post.id"
          :key="i"
          :ref="'cloudposts-' + i"
          :post="post"
          :cloud="true"
        />
      </div>
      <div
        v-else
        class="h-112 p-36 flex flex-col justify-center items-center w-full lg:w-9/12 bg-truegray-500"
      >
        <lottie :options="loadingAnimationOptions" />
        <span class="text-white text-center">Loading posts</span>
      </div>
      <!-- /posts -->
    </div>
    <!-- /Latest posts -->

    <!--
      <div class="w-full mt-4">
      <Contributors />
      </div> 
    -->
    <div class="w-full mt-4">
      <Registration />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import Contributors from '../components/Contributors.vue'
import Registration from '../components/Registration.vue'
import PostsCard from '../../../shared/components/PostsCard.vue'
import * as loadingAnimation from '../../../shared/components/loading.json'

export default {
  components: {
    // Contributors,
    PostsCard,
    Registration,
  },

  data() {
    return {
      loadingAnimationOptions: { animationData: loadingAnimation.default },
      loadingAnimate: false,

      activePost: 0,
      postChanging: false,

      loaded: false,

      posts: [],

      pagination: {
        current_page: null,
        total_pages: null,
        per_page: 9,
        next_page: null,
        previous_page: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null,
        nextpage: null,
        previouspage: null,
      },
    }
  },

  computed: {
    ...mapGetters({
      settings: 'shared/getSettings',
    }),
  },

  mounted() {
    this.getPosts()
  },

  methods: {
    goToPosts() {
      this.$router.push({ name: 'Cloudposts' })
    },

    signup() {
      this.$scrollTo('#signUp')
    },

    scrollLeft() {
      if (this.activePost > 0) {
        this.$set(this, 'postChanging', true)
        this.$set(this, 'activePost', this.activePost - 1)
        this.changeMenuPosition()
        setTimeout(() => {
          this.$set(this, 'postChanging', false)
        }, 400)
      }
    },

    scrollRight() {
      if (this.activePost < this.posts.length - 1) {
        this.$set(this, 'postChanging', true)
        this.$set(this, 'activePost', this.activePost + 1)
        this.changeMenuPosition()
        setTimeout(() => {
          this.$set(this, 'postChanging', false)
        }, 400)
      }
    },

    getPosts() {
      let submitData = {}

      axios.post('/api/cloud-posts', submitData).then((response) => {
        let result = response.data
        if (result.success) {
          this.$set(this, 'posts', result.posts)
          this.$set(this, 'loaded', true)

          // pagination.total = total # of posts. / by per_page, + 1. Pagination doesnt show when not needed so +1 is never wrong on single page
          let total_pages =
            Math.floor(
              response.data.pagination.total /
                response.data.pagination.per_page,
            ) + 1
          this.$set(
            this.pagination,
            'current_page',
            response.data.pagination.current_page,
          )
          this.$set(this.pagination, 'total_pages', total_pages)
          this.$set(
            this.pagination,
            'per_page',
            response.data.pagination.per_page,
          )
          this.$set(
            this.pagination,
            'last_page_url',
            response.data.pagination.last_page_url,
          )
          this.$set(
            this.pagination,
            'next_page_url',
            response.data.pagination.next_page_url,
          )
          this.$set(
            this.pagination,
            'prev_page_url',
            response.data.pagination.prev_page_url,
          )
          this.$set(
            this.pagination,
            'path',
            response.data.pagination.next_page_path,
          )

          let prev = null
          if (this.pagination.prev_page_url) {
            prev = this.pagination.prev_page_url.split('=')
            prev = prev[1]
          }

          let next = null
          if (this.pagination.next_page_url) {
            next = this.pagination.next_page_url.split('=')
            next = next[1]
          }

          this.$set(this.pagination, 'previouspage', prev)
          this.$set(this.pagination, 'nextpage', next)
        } else {
          //...
        }
      })
    },
  },
}
</script>

<style scoped>
@media screen and (max-width: 1024px) {
  .cloud-hero {
    height: calc(100vh - 6rem);
  }
}

.cloud-gradient:before {
  width: 150%;
  height: 100%;
  right: 0;
  top: 0;
  z-index: -1;
  position: absolute;
  content: '';
  background: linear-gradient(
      284.31deg,
      rgba(255, 71, 120, 0.8) 21.89%,
      rgba(255, 71, 120, 0) 51.68%
    ),
    linear-gradient(
      270deg,
      rgba(111, 54, 188, 0.9) 63.1%,
      rgba(111, 54, 188, 0) 100%
    );
}
@media screen and (max-width: 1024px) {
  .cloud-gradient:before {
    background: transparent;
  }
}
</style>
